'use client'

import { Text, Icon } from '@vinted/web-ui'
import { ArrowRight24, ArrowLeft24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import SliderWrapper from '../../../../components/SliderWrapper/SliderWrapper'
import SliderCard from './SliderCard'

const generateSlidersContent = () =>
  Array.from({ length: 5 }, (_, index) => index + 1).map(contentItemOrder => ({
    reviewer: `review_${contentItemOrder}.name`,
    country: `review_${contentItemOrder}.country`,
    review: `review_${contentItemOrder}.review`,
    imageFileName: `face-${contentItemOrder}`,
  }))

const ReviewsSection = () => {
  const translate = useTranslate('item_verification.reviews')
  const sliderCardObjects = generateSlidersContent()

  return (
    <section className="item-verification__reviews" data-testid="reviews">
      <div className="item-verification__reviews-content">
        <h2 className="item-verification__reviews-title">{translate('title')}</h2>
      </div>
      <div className="item-verification__reviews-content" data-testid="reviews-slider_container">
        <SliderWrapper
          childData={sliderCardObjects}
          childComponent={SliderCard}
          nextButton={<Icon name={ArrowRight24} />}
          previousButton={<Icon name={ArrowLeft24} />}
        />
      </div>
      <div className="item-verification__reviews-content">
        <div className="item-verification__reviews-caption">
          <div className="item-verification__reviews-note" data-testid="reviews-note">
            <Text as="h4" type="caption">
              {translate('note')}
            </Text>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ReviewsSection
